<script setup>
import PageHeader from '../common/PageHeader.vue';
</script>

<template>
  <div class="main">
    <PageHeader
      title="About WASPL"
      subtitle="Learn more about the platform and technologies"
      icon="bi-info-circle"
      color="pink"
    />
   
    <div class="content-section">
      <div class="about-card">
        <h3>🎓 WASPL Assessment Platform</h3>
        <p>WASPL is a comprehensive digital assessment platform designed for modern education.</p>
        <a href="https://waspl-wiki.wiquid.fr/" target="_blank" class="wiki-button">
          <i class="bi bi-book"></i> Access to WASPL-Wiki
        </a>
      </div>

      <div class="about-card">
        <h3>🛠️ Technologies</h3>
        <ul class="tech-list">
          <li><i class="bi bi-check-circle-fill text-success"></i> Vue.js 3 - Modern reactive framework</li>
          <li><i class="bi bi-check-circle-fill text-success"></i> Bootstrap 5 - Responsive design</li>
          <li><i class="bi bi-check-circle-fill text-success"></i> Pinia - State management</li>
          <li><i class="bi bi-check-circle-fill text-success"></i> Node.js + Express - Backend API</li>
          <li><i class="bi bi-check-circle-fill text-success"></i> MongoDB - Database</li>
        </ul>
      </div>

      <div class="about-card">
        <h3>🌐 More Information</h3>
        <p>Visit <a href="https://waspl.wiquid.fr" target="_blank">waspl.wiquid.fr</a> for more details and support.</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.main {
  background-color: #F8F9FA;
  padding: 20px;
  border-left: 1px gainsboro solid;
}

.content-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.about-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-left: 4px solid #C2185B;
}

.about-card h3 {
  font-size: 1.3rem;
  font-weight: 700;
  color: #AD1457;
  margin-bottom: 16px;
}

.about-card p {
  color: #424242;
  line-height: 1.6;
  margin: 0;
}

.tech-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.tech-list li {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  color: #424242;
  font-size: 0.95rem;
}

.tech-list i {
  font-size: 1.1rem;
}

.about-card a {
  color: #1976D2;
  font-weight: 600;
  text-decoration: none;
}

.about-card a:hover {
  text-decoration: underline;
}

.wiki-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  padding: 10px 20px;
  background-color: #C2185B;
  color: white !important;
  border-radius: 8px;
  font-weight: 600;
  text-decoration: none !important;
  transition: all 0.3s ease;
}

.wiki-button:hover {
  background-color: #AD1457;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(194, 24, 91, 0.3);
}

.wiki-button i {
  font-size: 1.2rem;
}
</style>